/* LUCA — click-to-play YouTube facade.
   The poster image stands in for the player so no YouTube script, cookie or
   request happens until the visitor actually presses play. */
(function () {
  'use strict';

  function buildPlayer(host) {
    var id = host.getAttribute('data-luca-yt');
    if (!id || host.classList.contains('is-playing')) return;

    var frame = document.createElement('iframe');
    frame.className = 'luca-howto__iframe';
    frame.src =
      'https://www.youtube-nocookie.com/embed/' +
      encodeURIComponent(id) +
      '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
    frame.title = host.getAttribute('data-luca-yt-title') || 'Video';
    frame.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    frame.setAttribute('allowfullscreen', '');
    frame.setAttribute('frameborder', '0');

    host.classList.add('is-playing');
    host.innerHTML = '';
    host.appendChild(frame);
    host.removeAttribute('role');
    host.removeAttribute('tabindex');
    host.removeAttribute('aria-label');
  }

  function bind(host) {
    if (host.dataset.lucaYtBound) return;
    host.dataset.lucaYtBound = '1';
    host.addEventListener('click', function () {
      buildPlayer(host);
    });
    host.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        buildPlayer(host);
      }
    });
  }

  function init(root) {
    var nodes = (root || document).querySelectorAll('[data-luca-yt]');
    for (var i = 0; i < nodes.length; i++) bind(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
